(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offhoo-footer"] && !Shopify.designMode) return;
  try {
    
  class OffhooFooterLanguage extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-trigger]');
      this.panel = this.querySelector('[data-panel]');
      if (!this.trigger || !this.panel) return;

      this.onTriggerClick = () => this.toggle();
      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      this.onKeyDown = (event) => {
        if (event.key === 'Escape') {
          this.close();
          this.trigger.focus();
        }
      };

      this.trigger.addEventListener('click', this.onTriggerClick);
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.onTriggerClick);
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keydown', this.onKeyDown);
    }

    get isOpen() {
      return !this.panel?.hasAttribute('hidden');
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.panel.removeAttribute('hidden');
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.panel.setAttribute('hidden', '');
      this.trigger.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('offhoo-footer-language')) {
    customElements.define('offhoo-footer-language', OffhooFooterLanguage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offhoo-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 750px)');

    document.querySelectorAll('[data-mobile-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-carousel-track]');
      const slides = [...carousel.querySelectorAll('.offhoo-hero__mobile-slide')];
      const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
      if (!track || slides.length < 2) return;

      let activeIndex = 0;
      let startX = 0;
      let pointerDown = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        track.style.transform = `translateX(-${activeIndex * 100}%)`;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('aria-hidden', !active);
          slide.tabIndex = active ? 0 : -1;
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.carouselDot))));
      carousel.addEventListener('pointerdown', (event) => {
        pointerDown = true;
        startX = event.clientX;
      });
      carousel.addEventListener('pointerup', (event) => {
        if (!pointerDown) return;
        pointerDown = false;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 40) showSlide(activeIndex + (distance < 0 ? 1 : -1));
      });
      carousel.addEventListener('pointercancel', () => { pointerDown = false; });

      if (!reducedMotion) {
        window.setInterval(() => {
          if (window.matchMedia('(max-width: 767px)').matches && !document.hidden) showSlide(activeIndex + 1);
        }, 5000);
      }
    });

    document.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('a.offhoo-hero__banner-link--web[data-desktop-target="_blank"]');
        if (!link) return;
        if (!desktopQuery.matches) return;

        const href = link.getAttribute('href');
        if (!href) return;

        event.preventDefault();
        window.open(href, '_blank', 'noopener,noreferrer');
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offhoo-product-shelf"] && !Shopify.designMode) return;
  try {
    
  class OffhooProductShelf extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-shelf-scroller]');
      this.previousButton = this.querySelector('[data-shelf-prev]');
      this.nextButton = this.querySelector('[data-shelf-next]');

      this.handlePrevious = () => this.scrollByPage(-1);
      this.handleNext = () => this.scrollByPage(1);
      this.handleScroll = () => this.updateArrows();
      this.handleKeydown = (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.scrollByPage(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.scrollByPage(1);
        }
      };

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.scroller?.addEventListener('scroll', this.handleScroll, { passive: true });
      this.scroller?.addEventListener('keydown', this.handleKeydown);

      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      if (this.scroller) {
        this.resizeObserver.observe(this.scroller);
      }

      this.updateArrows();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.scroller?.removeEventListener('scroll', this.handleScroll);
      this.scroller?.removeEventListener('keydown', this.handleKeydown);
      this.resizeObserver?.disconnect();
    }

    scrollByPage(direction) {
      if (!this.scroller) return;

      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.scroller.scrollBy({
        left: this.scroller.clientWidth * direction,
        behavior,
      });
    }

    updateArrows() {
      if (!this.scroller) return;

      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth - 2;
      const atStart = this.scroller.scrollLeft <= 2;
      const atEnd = this.scroller.scrollLeft >= maxScroll;

      if (this.previousButton) {
        this.previousButton.disabled = atStart;
      }

      if (this.nextButton) {
        this.nextButton.disabled = maxScroll <= 0 || atEnd;
      }
    }
  }

  if (!customElements.get('offhoo-product-shelf')) {
    customElements.define('offhoo-product-shelf', OffhooProductShelf);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offhoo-scene-grid"] && !Shopify.designMode) return;
  try {
    
  class OffhooSceneCarousel {
    constructor(viewport) {
      this.viewport = viewport;
      this.track = viewport.querySelector('.offhoo-scene-grid__list');
      this.dots = Array.from(viewport.querySelectorAll('[data-scene-dot]'));
      this.autoplayEnabled = viewport.dataset.autoplay === 'true';
      this.intervalMs = Math.max(1, Number(viewport.dataset.autoplayInterval) || 2) * 1000;
      this.index = 0;
      this.timer = null;
      this.isInView = true;
      this.isPointerDown = false;
      this.didSwipe = false;
      this.dragX = 0;
      this.startX = 0;
      this.startY = 0;
      this.lockAxis = null;
      this.looping = false;
      this.realCards = [];
      this.slides = [];
      this.mobileQuery = window.matchMedia('(max-width: 749px)');

      this._onResize = () => this.render(false);
      this._onVisibility = () => this.syncPlayback();
      this._onMobileChange = () => {
        this.dragX = 0;
        this.setupLoop();
        this.render(false);
        this.updateDots();
        this.syncPlayback();
      };
      this._onStart = (event) => this.onStart(event);
      this._onMove = (event) => this.onMove(event);
      this._onEnd = (event) => this.onEnd(event);
      this._onClick = (event) => this.onClick(event);
      this._onDotClick = (event) => this.onDotClick(event);
      this._onTransitionEnd = (event) => this.onTransitionEnd(event);

      if (typeof this.mobileQuery.addEventListener === 'function') {
        this.mobileQuery.addEventListener('change', this._onMobileChange);
      } else {
        this.mobileQuery.addListener(this._onMobileChange);
      }

      window.addEventListener('resize', this._onResize, { passive: true });
      document.addEventListener('visibilitychange', this._onVisibility);
      this.viewport.addEventListener('pointerdown', this._onStart);
      this.viewport.addEventListener('pointermove', this._onMove, { passive: false });
      this.viewport.addEventListener('pointerup', this._onEnd);
      this.viewport.addEventListener('pointercancel', this._onEnd);
      this.viewport.addEventListener('click', this._onClick, true);
      this.track.addEventListener('transitionend', this._onTransitionEnd);
      this.dots.forEach((dot) => dot.addEventListener('click', this._onDotClick));

      if (typeof IntersectionObserver === 'function') {
        this._io = new IntersectionObserver(
          (entries) => {
            this.isInView = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.15);
            this.syncPlayback();
          },
          { threshold: [0, 0.15, 0.5] }
        );
        this._io.observe(this.viewport);
      }

      this.setupLoop();
      this.render(false);
      this.updateDots();
      requestAnimationFrame(() => this.syncPlayback());
    }

    destroy() {
      this.stop();
      this.teardownLoop();
      if (this._io) this._io.disconnect();
      if (typeof this.mobileQuery.removeEventListener === 'function') {
        this.mobileQuery.removeEventListener('change', this._onMobileChange);
      } else {
        this.mobileQuery.removeListener(this._onMobileChange);
      }
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('visibilitychange', this._onVisibility);
      this.viewport.removeEventListener('pointerdown', this._onStart);
      this.viewport.removeEventListener('pointermove', this._onMove);
      this.viewport.removeEventListener('pointerup', this._onEnd);
      this.viewport.removeEventListener('pointercancel', this._onEnd);
      this.viewport.removeEventListener('click', this._onClick, true);
      this.track.removeEventListener('transitionend', this._onTransitionEnd);
      this.dots.forEach((dot) => dot.removeEventListener('click', this._onDotClick));
      this.track.style.transform = '';
      this.track.classList.remove('is-dragging');
    }

    teardownLoop() {
      this.track.querySelectorAll('[data-scene-clone]').forEach((node) => node.remove());
      this.looping = false;
      this.realCards = Array.from(this.track.querySelectorAll('.offhoo-scene-grid__card'));
      this.slides = this.realCards;
    }

    setupLoop() {
      this.teardownLoop();
      if (!this.mobileQuery.matches || this.realCards.length < 2) {
        this.index = 0;
        return;
      }

      const first = this.realCards[0];
      const last = this.realCards[this.realCards.length - 1];
      const cloneFirst = first.cloneNode(true);
      const cloneLast = last.cloneNode(true);
      cloneFirst.setAttribute('data-scene-clone', 'first');
      cloneLast.setAttribute('data-scene-clone', 'last');
      cloneFirst.setAttribute('tabindex', '-1');
      cloneLast.setAttribute('tabindex', '-1');
      cloneFirst.setAttribute('aria-hidden', 'true');
      cloneLast.setAttribute('aria-hidden', 'true');

      this.track.insertBefore(cloneLast, first);
      this.track.appendChild(cloneFirst);
      this.slides = Array.from(this.track.querySelectorAll('.offhoo-scene-grid__card'));
      this.looping = true;
      this.index = 1;
    }

    get gap() {
      return Number.parseFloat(getComputedStyle(this.track).gap) || 0;
    }

    get step() {
      return this.viewport.clientWidth + this.gap;
    }

    realIndex() {
      if (!this.looping || !this.realCards.length) return this.index;
      const n = this.realCards.length;
      if (this.index <= 0) return n - 1;
      if (this.index >= n + 1) return 0;
      return this.index - 1;
    }

    updateDots() {
      const active = this.realIndex();
      this.dots.forEach((dot, i) => {
        const on = i === active;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    render(animate = true) {
      if (!this.track) return;
      if (!this.mobileQuery.matches) {
        this.track.style.transform = '';
        this.track.classList.remove('is-dragging');
        return;
      }
      if (animate && !this.isPointerDown) this.track.classList.remove('is-dragging');
      else this.track.classList.add('is-dragging');
      const x = this.index * this.step - this.dragX;
      this.track.style.transform = 'translate3d(' + -x + 'px, 0, 0)';
    }

    normalizeLoop() {
      if (!this.looping) return;
      const n = this.realCards.length;
      if (this.index === 0) {
        this.index = n;
        this.render(false);
      } else if (this.index === n + 1) {
        this.index = 1;
        this.render(false);
      }
    }

    onTransitionEnd(event) {
      if (event.target !== this.track || event.propertyName !== 'transform') return;
      this.normalizeLoop();
    }

    goTo(index, animate = true) {
      if (!this.slides.length) return;
      if (!this.looping) {
        const total = this.slides.length;
        this.index = ((index % total) + total) % total;
      } else {
        this.index = index;
      }
      this.dragX = 0;
      this.render(animate);
      this.updateDots();
      if (!animate) this.normalizeLoop();
    }

    goNext(animate = true) {
      this.goTo(this.index + 1, animate);
    }

    goPrev(animate = true) {
      this.goTo(this.index - 1, animate);
    }

    syncPlayback() {
      const canPlay =
        this.autoplayEnabled &&
        this.mobileQuery.matches &&
        !document.hidden &&
        !this.isPointerDown &&
        this.isInView &&
        this.realCards.length > 1;

      if (canPlay) this.start();
      else this.stop();
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.goNext(), this.intervalMs);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    onStart(event) {
      if (!this.mobileQuery.matches || this.realCards.length < 2) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('[data-scene-dot]')) return;
      if (this.isPointerDown) return;
      this.normalizeLoop();
      this.isPointerDown = true;
      this.didSwipe = false;
      this.lockAxis = null;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.dragX = 0;
      this.stop();
      this.track.classList.add('is-dragging');
      try {
        this.viewport.setPointerCapture(event.pointerId);
      } catch (_e) {}
    }

    onMove(event) {
      if (!this.isPointerDown || !this.mobileQuery.matches) return;
      const dx = event.clientX - this.startX;
      const dy = event.clientY - this.startY;
      if (!this.lockAxis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        this.lockAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (this.lockAxis !== 'x') return;
      if (event.cancelable) event.preventDefault();
      this.dragX = dx;
      this.render(false);
    }

    onEnd(event) {
      if (!this.isPointerDown) return;
      this.isPointerDown = false;
      this.track.classList.remove('is-dragging');

      if (this.lockAxis === 'x') {
        const dx = event.clientX - this.startX;
        const threshold = Math.min(56, this.viewport.clientWidth * 0.18);
        if (Math.abs(dx) >= 8) this.didSwipe = true;
        if (dx <= -threshold) this.goNext();
        else if (dx >= threshold) this.goPrev();
        else this.goTo(this.index);
      } else {
        this.dragX = 0;
        this.render(true);
      }

      this.lockAxis = null;
      this.syncPlayback();
    }

    onClick(event) {
      if (!this.didSwipe) return;
      event.preventDefault();
      event.stopPropagation();
      this.didSwipe = false;
    }

    onDotClick(event) {
      if (!this.mobileQuery.matches) return;
      const next = Number(event.currentTarget.dataset.sceneDot);
      if (Number.isNaN(next)) return;
      this.normalizeLoop();
      this.goTo(this.looping ? next + 1 : next);
      this.syncPlayback();
    }
  }

  function initOffhooSceneCarousels(root = document) {
    root.querySelectorAll('[data-scene-carousel]').forEach((viewport) => {
      if (viewport._offhooSceneCarousel) viewport._offhooSceneCarousel.destroy();
      viewport._offhooSceneCarousel = new OffhooSceneCarousel(viewport);
    });
  }

  initOffhooSceneCarousels();
  document.addEventListener('shopify:section:load', (event) => {
    initOffhooSceneCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
